import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  return <>
      <PageHeader title="Contact Us" backgroundImage="https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&w=1920&q=80" data-id="element-909" />
      <ContactSection data-id="element-910" />
    </>;
}